// extracted by mini-css-extract-plugin
module.exports = {"root":"IconCard_root__k1K0x"};